DialogAddUserUniGesCtrl.$inject = ['$log', '$scope', '$http'];
export default function DialogAddUserUniGesCtrl($log, $scope, $http) {
    const URL_MANT_UNI_GES = Sigo.var.path + '/mantenimiento/unidad-gestion-acciones';

    var vm = this;

    vm.model = $scope.model;
    vm.dialogHandler = $scope.dialog;
    vm.cargando = {
        datos: true,
        submit: false
    };
    vm.formDeshabilitado = true;
    var idUniGes = vm.model.idUniGes;

    cargarUsuarios();

    function cargarUsuarios() {
        var url = URL_MANT_UNI_GES + '/add-usuario/' + idUniGes;
        var promise = $http.get(url);
        promise.then(function (data) {
            vm.usuarios = data.data.usuarios;
            vm.cargando.datos = false;
            vm.formDeshabilitado = false;

            if (vm.usuarios.length < 1) {
                vm.dialogHandler.cancel();
                $.toast({
                    heading: 'Advertencia',
                    text: "Ya se han añadido todos los usuarios",
                    showHideTransition: 'slide',
                    icon: 'warning'
                });
            }
        });
    }

    vm.submitUser = submitUser;

    function submitUser(userSeleccionado) {
        vm.cargando.submit = true;
        vm.formDeshabilitado = true;

        var userId = null;
        if (typeof userSeleccionado.id !== 'undefined') userId = userSeleccionado.id;

        var url = URL_MANT_UNI_GES + '/add-usuario/' + idUniGes + '/' + userId;

        var promise = $http.post(url);
        promise.then(function (data) {
            $.toast({
                heading: 'Añadido',
                text: 'Usuario añadido',
                showHideTransition: 'slide',
                icon: 'success'
            });

            vm.dialogHandler.close(data);
            //TODO: COntrolar errores
        }, function () {
            $.toast({
                heading: 'Error',
                text: Lang.get('mensajes.error_mensaje'),
                showHideTransition: 'slide',
                icon: 'error'
            });

        });
    }

    vm.cancelar = function () {
        vm.dialogHandler.cancel();
    }
}
